// Header.js

import React from 'react';
import './Header.css';
import Navigation from './Navigation';



const Header = () => {
  return (
    <header>
      <Navigation/>
    </header>
  );
};

export default Header;
